import { render, staticRenderFns } from "./RefundAmountForm.vue?vue&type=template&id=272b1e44&scoped=true"
import script from "./RefundAmountForm.vue?vue&type=script&lang=js"
export * from "./RefundAmountForm.vue?vue&type=script&lang=js"
import style0 from "./RefundAmountForm.vue?vue&type=style&index=0&id=272b1e44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272b1e44",
  null
  
)

export default component.exports